export default __webpack_public_path__ + "static/media/tep_icon_mail.22010417.svg";